import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { AuthenticationContextDatasourceService } from '../../backend/datasource/authentication-context-datasource.service';

@Injectable()
export class UserChoicesGuardService implements CanActivate {
  private authenticationContextDatasource = inject(AuthenticationContextDatasourceService);
  private router = inject(Router);

  canActivate(route: ActivatedRouteSnapshot): boolean {
    const id = route.queryParams['id'];

    if (!id) {
      this.router.navigate(['idp']);
      return false;
    }

    this.authenticationContextDatasource.setSessionId(id);

    return true;
  }
}
